import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../../Field'
import { FormFieldsContainer } from '../../../../Form'
import { PhoneSelectFormikField } from '../../../../Phone'
import { LOGIN_FORM_FIELD_HEIGHT } from '../../Login.constants'
import { LOGIN_FORM_PHONE_NUMBER_FIELD_NAME_PHONE } from '../LoginFormPhoneNumber'

function LoginFormPhoneNumberFields({ isLoading }) {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <PhoneSelectFormikField
        autoFocus
        Field={FieldStackedLabel}
        controlProps={{
          borderless: false,
          height: LOGIN_FORM_FIELD_HEIGHT,
        }}
        disabled={isLoading}
        fieldComponentProps={{
          label: t('Auth.SignInByPhoneLabelKey'),
        }}
        name={LOGIN_FORM_PHONE_NUMBER_FIELD_NAME_PHONE}
      />
    </FormFieldsContainer>
  )
}

export default LoginFormPhoneNumberFields
